import React from 'react';
import axios from 'axios';
import moment from 'moment';

import { useTimeModal } from '../../TimeModal/TimeModalContext';
import { pluralizeMonth, formatDate, isDatePastInMoscow, formatNull } from '../../../Utils/GlobalUtils';

import Loading from '../../Loading';

const ReportIntervalPanel = ({ caseId, reloadBoxes }) => {
    const { openTimeModal } = useTimeModal();

    const [formInfo, setFormInfo] = React.useState([]);
    const [newReportInterval, setNewReportInterval] = React.useState('');
    const [newDateEnd, setNewDateEnd] = React.useState('');
    const [reload, setReload] = React.useState(true);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        axios.get(`/api/get-main-accounting-case-info?case_id=${caseId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then((response) => {
            setFormInfo(response.data);
        })
        .catch((error) => {
            console.error(error);
            openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
        })
        .finally(() => {
            setLoading(false);
            setReload(false);
        })
    }, [reload, caseId, reloadBoxes]);

    const changeReportInterval = (interval) => {
        const token = localStorage.getItem('token');

        setLoading(true);
        setNewReportInterval(interval);

        axios.put(`/api/change-report-interval?case_id=${caseId}&interval=${interval}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
        })
        .then(() => {
            openTimeModal('Новый срок установлен', 'success');
            setReload(true);
        })
        .catch((error) => {
            openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
        })
        .finally(() => {
            setLoading(false);
            setNewReportInterval('');
            setIsChangeReportInterval(false);
        })
    };

    const changeDateEnd = () => {
        const token = localStorage.getItem('token');

        setLoading(true);

        axios.put(`/api/change-date-end?case_id=${caseId}&date_next_meeting_creditors=${newDateEnd}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
        })
        .then(() => {
            openTimeModal('Дата следующего собрания кредиторов изменена', 'success');
            setReload(true);
        })
        .catch((error) => {
            openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
        })
        .finally(() => {
            setLoading(false);
            setNewDateEnd('');
            setIsChangeDateEnd(false);
        })
    };

    const [isChangeReportInterval, setIsChangeReportInterval] = React.useState(false);
    const [isChangeDateEnd, setIsChangeDateEnd] = React.useState(false);


    return (
        <div className='horizontalContainer'>
            <div className={`boxPage`}>
                <div className={`boxHeader ${isDatePastInMoscow(formInfo.date_next_meeting_creditors) ? 'boxAttention' : ''}`}>
                    <div>
                        <h3>Срок предоставления следующего отчёта</h3>
                    </div>
                    <div className='image'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 256 256"><path d="M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM169.66,133.66l-48,48a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L116,164.69l42.34-42.35a8,8,0,0,1,11.32,11.32ZM48,80V48H72v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80Z"></path></svg>
                    </div>
                </div>
                <div className='boxMain'>
                    {loading ? <Loading type='inline' /> : <h2>Предоставление отчётности один раз в {formInfo.report_interval ? `${formInfo.report_interval} ${pluralizeMonth(formInfo.report_interval)}` : '—'}</h2>}
                    {<p className='description'>Следующий отчёт рекомендуется предоставить до {loading ? 'Загрузка...' : (formInfo.date_next_meeting_creditors ? formatDate(moment(formInfo.date_next_meeting_creditors).subtract(20, "days").format("YYYY-MM-DD")): formatNull())} (за 20 дней до следующего собрания кредиторов)</p>}
                </div>
                <div className='boxFooter'>
                    {!isChangeReportInterval ? 
                        <button type='button' className='button' onClick={() => {setIsChangeReportInterval(true)}}>Изменить</button> 
                    :
                        <div className='radioSwitchWrapper'>
                            <label className={`radioSwitchLabel ${newReportInterval === '1' ? 'selected' : ''}`}>
                                <input
                                    type='radio'
                                    name='typeSelector'
                                    value='1'
                                    checked={newReportInterval === '1'}
                                    onChange={(e) => {changeReportInterval(e.target.value)}}
                                />
                                <span>Раз в месяц</span>
                            </label>
                            <label className={`radioSwitchLabel ${newReportInterval === '3' ? 'selected' : ''}`}>
                                <input
                                    type='radio'
                                    name='typeSelector'
                                    value='3'
                                    checked={newReportInterval === '3'}
                                    onChange={(e) => {changeReportInterval(e.target.value)}}
                                />
                                <span>Раз в квартал</span>
                            </label>
                            <label className={`radioSwitchLabel ${newReportInterval === '6' ? 'selected' : ''}`}>
                                <input
                                    type='radio'
                                    name='typeSelector'
                                    value='6'
                                    checked={newReportInterval === '6'}
                                    onChange={(e) => {changeReportInterval(e.target.value)}}
                                />
                                <span>Раз в полгода</span>
                            </label>
                        </div>
                    }
                </div>
            </div>

            <div className={`boxPage ${isDatePastInMoscow(formInfo.next_meeting_date) ? 'boxAttention' : ''}`}>
                <div className='boxHeader'>
                    <div>
                        <h3>Следующее собрание (комитета) кредиторов</h3>
                    </div>
                    <div className='image'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 256 256"><path d="M164.38,181.1a52,52,0,1,0-72.76,0,75.89,75.89,0,0,0-30,28.89,12,12,0,0,0,20.78,12,53,53,0,0,1,91.22,0,12,12,0,1,0,20.78-12A75.89,75.89,0,0,0,164.38,181.1ZM100,144a28,28,0,1,1,28,28A28,28,0,0,1,100,144Zm147.21,9.59a12,12,0,0,1-16.81-2.39c-8.33-11.09-19.85-19.59-29.33-21.64a12,12,0,0,1-1.82-22.91,20,20,0,1,0-24.78-28.3,12,12,0,1,1-21-11.6,44,44,0,1,1,73.28,48.35,92.18,92.18,0,0,1,22.85,21.69A12,12,0,0,1,247.21,153.59Zm-192.28-24c-9.48,2.05-21,10.55-29.33,21.65A12,12,0,0,1,6.41,136.79,92.37,92.37,0,0,1,29.26,115.1a44,44,0,1,1,73.28-48.35,12,12,0,1,1-21,11.6,20,20,0,1,0-24.78,28.3,12,12,0,0,1-1.82,22.91Z"></path></svg>
                    </div>
                </div>
                <div className='boxMain'>
                    {!isChangeDateEnd ? 
                        <h2>{loading ? 'Загрузка...' : formatDate(formInfo.date_next_meeting_creditors)}</h2>
                    :
                        <input type='date' 
                        value={formInfo.newDateEnd?.split('T')[0]}
                        onChange={(e) => setNewDateEnd(e.target.value)} 
                        placeholder='' 
                        minLength='' 
                        maxLength='' 
                        required 
                        />
                    }
                </div>
                <div className='boxFooter' style={{justifyContent: !isChangeDateEnd ? 'space-between' : 'flex-end'}}>
                    {!isChangeDateEnd ? 
                        <button type='button' className='button' onClick={() => {setIsChangeDateEnd(true)}}>Изменить</button> 
                    :
                        <>
                            <button type='button' className='button optionalButton' onClick={() => {setIsChangeDateEnd(false)}}>Отменить</button>
                            <button type='button' className='button' onClick={changeDateEnd}>Готово</button>
                        </>
                    }
                </div>
            </div>
        </div>
    )
}

export default ReportIntervalPanel;